// extracted by mini-css-extract-plugin
export default {"item":"TechnicalSupportIssueSidebar_item__gD8r6"};